<!--
/*******************************************************************************
*@ 컴포넌트명   : PushStupNoPopup.vue
*@ 컴포넌트설명 : PushNo안내팝업
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <!-- 앱 PUSH 안내 -->
    <modal-pop
      :opened.sync="isNoPopupOpen"
      :modalHeader="true"
      :modalFooter="true"
      :btnClose="true"
      :titleCenter="true"
      title="MPSH-01-01-00-09"
    >
      <template #content>
        <strong class="info-question mtop-12 btm-border">
          <!-- 2021.12.21 이 기기로<br />PUSH 알림을 받는 것에 거부 하셨습니다. -->
          {{$getGlobalDateFmt(today)}} {{$t("MPSH-01-01-02-02")}}
        </strong>
        <div class="desc mtop-12 mbtm-12">
          <!-- 다시 수신설정을 하시려면<br />[메인 > 알림서비스 > 알림설정] 메뉴에서 알림설정을 변경하실 수있습니다. -->
          {{$t("MPSH-01-01-02-03")}}
        </div>
      </template>
      <template #footer>
        <!-- 2022-02-04 수정 -->
        <button class="btn bottom negative" @click="() => {isNoPopupOpen = false}">
          <!-- 닫기 -->
          {{$t("MPSH-01-01-00-03")}}
        </button>
        <button
          class="btn bottom positive"
          @click="() =>{ $router.push({ name: 'pushNotiStup' }) }"
        >
          <!-- 알림 설정 -->
          {{$t("MPSH-01-01-00-08")}}
        </button>
      </template>
    </modal-pop>
  </article>
</template>
<script>
export default {
  props: ["opened"],
  mounted() {},
  created() {},
  data() {
    return {
      today: this.$getDateToString(),
    };
  },
  computed: {
    isNoPopupOpen: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {},
};
</script>
